import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  border-bottom: 1px solid ${({ theme }) => theme.semanticColors.ui[6]};
  padding: 15px;
  background-color: ${({ theme }) => theme.semanticColors.ui[5]};
  color: ${({ theme }) => theme.semanticColors.text.inverse.primary};
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const StyledIconLink = styled.a`
  color: ${({ theme }) => theme.semanticColors.text.inverse.primary};
  font-size: 20px;
  cursor: pointer;
`;

export const CollapseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 4px;
  background-color: transparent;
  color: ${({ theme }) => theme.semanticColors.text.interactive};
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: ${({ theme }) => theme.semanticColors.hover.secondary};
  }
`;
